module.exports = __webpack_public_path__ + "img/img04.7d97bcc3.jpg";